module.exports = __webpack_public_path__ + "img/Villa_Borna_9.3360d77e.jpg";